<template>

    <m-edit1/>

    <m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"border-radius:35px;\nbackground:#CCF18660;"' class="fixed-bottom  text-dark site-layout  shadow m-5 p-3 border d-print-none" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="d-flex text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='"border-radius:25px;\n"' class="flex-fill pt-3 mx-3 bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"house-heart"},...{}}' :style='""' class="h1 text-dark" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:35px;"' class="text-dark" >
                <template #default>بازگشت   </template>
                </m-p></template>
                </m-a></template>
                </m-div></template>
                </m-a><m-a v-bind='{...{"href":"{\"name\":\"nobat\",\"params\":{}}","target":"_self"},...{}}' :style='"border-radius:25px;"' class="flex-fill pt-3 bg-secondary mx-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"nobat\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"calendar2-plus"},...{}}' :style='""' class="h1 text-white" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:35px;"' class="text-white" >
                <template #default>نوبت دهی   </template>
                </m-p></template>
                </m-a></template>
                </m-div></template>
                </m-a><m-a v-bind='{...{"href":"{\"name\":\"nemonekar\",\"params\":{}}","target":"_self"},...{}}' :style='"border-radius:25px;"' class="flex-fill pt-3 bg-secondary mx-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"nemonekar\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"journals"},...{}}' :style='""' class="h1 text-white" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:35px;"' class="text-white" >
                <template #default>نمونه کار   </template>
                </m-p></template>
                </m-a></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mLoading3,mUpdateSiteMessage1,mDiv,mA,mIcon,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
